import  { useState } from "react";
import Footer from "./Footer";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import contactimg from "../Assets/images/contact-img.png";

function Contact() {
  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prevent non-numeric input in phoneNumber
    if (name === "phoneNumber" && /[^0-9]/.test(value)) return;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Remove error when valid input is provided
    if (value.trim() !== "") {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Submit form or API call here
      console.log("Form submitted:", formData);
      setFormData({
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
      });
    }
  };
  return (
    <>
    <div className="container">
      <div className="container sub-page">
        <Container style={{ padding: "60px 0 0" }}>
          {/* <h1 className="fw-bold text-center">Contact Us</h1> */}
          <Row className="d-flex align-items-center justify-content-between mt-3 form-div">
            <Col lg={6} md={12} sm={12} className="">
              <Card className="contact-card" >
                <h1 className="fw-bold text-center">Contact Us</h1>
                <Form className="mt-3">
                  <Form.Group className="mb-3" controlId="fullNameInput">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      className="custom-placeholder"
                      name="fullName"
                      value={formData.fullName}
                      placeholder="Your Name"
                      onChange={handleChange}
                      autoComplete="off"
                      isInvalid={!!errors.fullName}
                    />
                    {errors.fullName && (
                      <Form.Control.Feedback type="invalid">
                        {errors.fullName}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="emailInput">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      className="custom-placeholder"
                      type="email"
                      name="email"
                      value={formData.email}
                      placeholder="Email Address"
                      onChange={handleChange}
                      autoComplete="off"
                      isInvalid={!!errors.email}
                    />
                    {errors.email && (
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="phoneNumberInput">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      className="custom-placeholder"
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      placeholder="Phone Number"
                      onChange={handleChange}
                      autoComplete="off"
                      isInvalid={!!errors.phoneNumber}
                    />
                    {errors.phoneNumber && (
                      <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="messageTextarea">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      // className="custom-placeholder"
                      placeholder="Type Your Message"
                      name="message"
                      value={formData.message}
                      as="textarea"
                      onChange={handleChange}
                      style={{ height: "90px" }}
                      isInvalid={!!errors.message}
                    />
                    {errors.message && (
                      <Form.Control.Feedback type="invalid">
                        {errors.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Button
                    onClick={handleSubmit}
                    className="btn mt-4 w-100"
                  >
                    <span>Submit</span>
                  </Button>
                </Form>
              </Card>
            </Col>
            <Col
              lg={6}
              md={12}
              sm={12}
              className="d-flex  contact-col"
            >
              <img src={contactimg} className="contact-img" style={{ height: "450px" }} alt="" />
            </Col>
          </Row>
          <div className="contact-content">
            <h3 className="fw-bold">We’re Here to Help</h3>
            <p className="mt-3">Have a question about our educational content or need clarification on a banking topic?
            We’re always happy to hear from our users.</p>
            <p>At Banksstatements.com, we focus on providing clear and easy to understand banking information. If something on our website needs improvement or you have a suggestion, feel free to reach out using the contact form.</p>
          </div>

          <div className="mt-5">
            <h3 className="fw-bold">What You Can Contact Us For</h3>
            <p className="mt-3">You can contact us regarding:</p>
            <div className="about">
            <ul className="pl-3">
              <li>Questions about our articles or explanations</li>
              <li>Suggestions for new educational topics</li>
              <li>Feedback on content accuracy or clarity</li>
              <li>General website related inquiries</li>
            </ul>
            </div>
            <p>We carefully review every message to ensure our content remains helpful and reliable.</p>
          </div>

          <div className="mt-5">
            <h3 className="fw-bold">Our Commitment</h3>
            <p className="mt-3">We are committed to maintaining transparency, accuracy, and user trust.
            Your feedback plays an important role in helping us improve and grow as an educational platform.</p>
          </div>
        </Container>
      </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
